import Vue from "vue";
import Router from "vue-router";

import account from "./account";
import dashboard from "./dashboard";
import admin from "./admin";
import system from "./system";
// import MenuUtils from '../views/layout/components/sidebar/models/MenuUtils';
import store from "../store/index";
import * as types from "../store/mutation-types";
import AppAuthService from "../services/common/AppAuthService";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";
import { debug } from "util";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
let router = new Router({
    routes: [
        {
            path: "/",
            redirect: "/dashboard/TenantDashboard",
            // redirect: 'account'
        },
        ...account,
        {
            path: "/layout",
            name: "admin.layout",
            component: (resolve) => {
                require.ensure([], () => {
                    resolve(require("../views/layout/Layout.vue"));
                });
            },
            meta: {
                permission: "Pages",
                requireAuthorized: true,
            },
            children: [...dashboard, ...admin, ...system],
        },
    ],
    base: "/views/",
    mode: "history",
});

function selectBestRoute() {
    if (cf.auth.isGranted("Pages.Administration.Host.Dashboard")) {
        return "admin.hostdashboard";
    }

    if (cf.auth.isGranted("Pages.Tenant.Dashboard")) {
        return "admin.tenantdashboard";
    }

    if (cf.auth.isGranted("Pages.Tenants")) {
        return "admin.tenants";
    }

    if (cf.auth.isGranted("Pages.PurchasedModuleUser")) {
        return "用户版本选择";
    }

    if (cf.session.userId == null) {
        AppAuthService.logout(false);
        return "account.login";
    } else {
        return "admin.WelCome";
    }
}

function getSelectedMenu(to, menu) {
    var fullPath = to.fullPath.toLowerCase();
    var permission = to.meta.permission;

    if (menu.path) {
        var path = menu.path.toLowerCase();
        var permissionName = menu.permissionName;
        if (fullPath == path && permission == permissionName) {
            return menu;
        }
    }

    var rs = null;
    for (var item of menu.items) {
        rs = getSelectedMenu(to, item);
        if (rs) break;
    }

    return rs;
}

router.beforeEach((to, from, next) => {
    document.title = window.lang(to.meta.title);
    // var selectedMenu = getSelectedMenu(to, MenuUtils.menu);
    // if (selectedMenu) {
    //     var menu = selectedMenu;
    //     store.commit(types.IndexSetActiveMenu, {
    //         menu
    //     });
    // }

    // 判断是否需要权限
    if (to.meta.requireAuthorized) {
        if (cf.session.userId == null) {
            next({
                name: "account.login",
            });
        }

        if (cf.auth.isGranted(to.meta.permission)) {
            next();
        } else {
            // selectBestRoute();
            next({
                name: selectBestRoute(),
            });
        }
    } else {
        next();
    }
});

router.beforeResolve((to, from, next) => {
    // console.log('beforeResolve');
    next();
});

router.afterEach((to, from) => {
    // console.log('afterEach');
});

export default router;
